import { EventEmitter, Injectable } from "@angular/core";
import { environment } from "@app/../environments/environment";
import { SpinnerService } from "@app/core/spinner/spinner.service";
import { Paho } from "ng2-mqtt/mqttws31";
import { Observable, Subject } from "rxjs";

@Injectable()
export class MqttService {
	private _client: Paho.MQTT.Client;
	private _topics: { [key: string]: (msg: Paho.MQTT.Message) => {} };
	private disconnectedEmitter = new EventEmitter<void>();

	get topics() { return Object.assign({}, this._topics); }

	constructor(private spinnerService: SpinnerService) {
		this._client = new Paho.MQTT.Client(environment.mqtt.host, environment.mqtt.port, "");
		// this._client.startTrace();
		this._topics = {};
	}

	disconnect() {
		if (this._client.isConnected()) {
			this._client.disconnect();
		}
		this._topics = {};
	}
	connect(force = false): Observable<Paho.MQTT.Client> {
		const subject = new Subject<Paho.MQTT.Client>();
		this.spinnerService.show(`MQTT connect -> ${environment.mqtt.host}`);

		if (force) {
			this.disconnect();
		}

		if (this._client.isConnected()) {
			this.spinnerService.hide(`MQTT already connected -> ${environment.mqtt.host}`, false);
			setTimeout(() => subject.next(this._client));
		} else {
			this._client.onConnectionLost = responseObject => {
				console.log("MQTT connection lost.", responseObject);
				this.disconnectedEmitter.emit();
				this.spinnerService.hide(`MQTT connection lost -> ${environment.mqtt.host}`, true);
			};

			console.log(this._client.getTraceLog());
			console.log("MQTT connecting...");

			this._client.connect({
				userName: environment.mqtt.username,
				password: environment.mqtt.password,
				useSSL: true,

				onSuccess: () => {
					this.spinnerService.hide(`MQTT connection established -> ${environment.mqtt.host}`, false);
					console.log("Connected to broker.");
					subject.next(this._client);
				},
				onFailure: () => {
					this.spinnerService.hide(`MQTT connection failed -> ${environment.mqtt.host}`, true);
					this.disconnectedEmitter.emit();
					console.log("Error connection to broker.");
				}
			});

			this._client.onMessageArrived = (message: Paho.MQTT.Message) => {
				console.log(message.destinationName, message.payloadString, this._topics[message.destinationName](message));
			};
		}

		return subject.asObservable();
	}

	topic = (...args) => environment.mqtt.topic.replace(/{(\d+)}/g, (match, i) => args[i]);

	subscribe(t: string, callback) {
		console.log("subscribing..." + t);
		if (this._client.isConnected()) {
			this._client.subscribe(t, {
				onSuccess: () => {
					console.log("subscribe to " + t);
					this._topics[t] = callback;
				}
			});
		}
	}

	disconnected = () => this.disconnectedEmitter;

	unsubscribe(t: string) {
		console.log("unsubscribing..." + t);
		if (this._client.isConnected()) {
			this._client.unsubscribe(t, {
				onSuccess: () => {
					console.log("unsubscribe " + t);
					delete this._topics[t];
				}
			});
		}
	}
}